<template>
  <div class="n-captcha">
    <NAsyncContainer :loading="loading">
      <div class="n-captcha-image" :style="imageStyle" @click="execute()">
        {{ errorMessage }}
      </div>
    </NAsyncContainer>
  </div>
</template>

<script setup>
import {computed, onMounted, reactive, ref} from 'vue';
import {loadCaptcha} from '@front/api/utility';
import {useExecute, useLanguage} from '@front/hooks';

const { tl } = useLanguage();

const captcha = reactive({
  id: '',
  imageBase64: '',
});

const emit = defineEmits(['update:id']);

const errorMessage = ref('');

const imageStyle = computed(() => ({ backgroundImage: `url("${captcha.imageBase64}")` }));

const { loading, execute } = useExecute({
  execute: async () => {
    try {
      const { id, imageBase64 } = await loadCaptcha({ width: 100, height: 40 });
      captcha.id = id;
      captcha.imageBase64 = 'data:image/jpeg;base64, ' + imageBase64;
      emit('update:id', id);
    } catch (err) {
      captcha.id = '';
      captcha.imageBase64 = '';
      errorMessage.value = tl('captchaImageErrorMsg');
      throw err;
    }
  },
});

onMounted(() => {
  execute();
});

defineExpose({ load: execute });
</script>

<script>
export default {
  name: 'NCaptcha',
};
</script>

<style lang="less">
.n-captcha {
  user-select: none;

  &-image {
    width: 100%;
    height: 40px;
    border-radius: @border-radius-base;
    border: 1px solid @border-color-base;
    cursor: pointer;
    //background-color: #eee;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    line-height: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    color: @warning-color;
  }

  .n-async-container {
    min-height: initial;
  }
}
</style>
